export enum TimelineEventKind {
    REGULAR = 0,
    BREAK_MARKER = 1,
}
